export function clientsideSetup () {
  function handleTabNavigation (e) {
    if (keyboardActive) { return }
    if (e.key === 'Tab' || e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      document.documentElement.classList.add('tabnav-active')
      keyboardActive = true
    }
  }

  function handleTouchAndMouseNavigation (e) {
    if (!keyboardActive) { return }
    document.documentElement.classList.remove('tabnav-active')
    keyboardActive = false
  }

  let keyboardActive = true
  document.documentElement.classList.add('tabnav-active')

  document.addEventListener('keydown', handleTabNavigation, false)
  document.addEventListener('mousemove', handleTouchAndMouseNavigation, false)
  document.addEventListener('touchstart', handleTouchAndMouseNavigation, false)
}
